<template>
    <div class="login">
        <div class="row">
            <label for="admin-id">ID</label>
            <input id="admin-id" type="text" autocomplete="username" v-model="userId" @keyup.enter="login"/>
        </div>
        <div class="row">
            <label for="admin-pw">Password</label>
            <input id="admin-pw" type="password" autocomplete="current-password" v-model="password" @keyup.enter="login"/>
        </div>
        <button type="button" class="row button" @click="login">로그인</button>
        <div class="row restore-link-container">
            <router-link :to="{ name: 'adminRestore' }" class="restore-link">데이터 복원 페이지로 이동</router-link>
        </div>
    </div>
</template>

<script>
import {Vue, Component} from 'vue-property-decorator'

@Component
export default class Login extends Vue {
    userId = ''
    password = ''

    async login () {
        try {
            await this.$store.dispatch('adminLogin', { id: this.userId, password: this.password })
            await this.$router.push({ name: 'adminApartments' }).catch(() => {})
        } catch (e) { alert('비밀번호가 틀렸습니다.') }
    }
}
</script>

<style scoped lang="scss">
@import 'src/assets/style/common';
@import 'src/assets/style/media-query';

.login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .row {
        margin: 5px 0;
    }
    label {
        display: inline-block;
        width: 70px;
    }
    input {
        border: 1px solid $transparent-dark-theme;
    }
    .restore-link-container {
        margin-top: 20px;
        font-size: 13px;
        .restore-link {
            color: #007bff;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
